// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3gUo4","validationTips":"StatementDescriptor_validationTips__3ouQJ"};